// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__olJEk","dragIcon":"SortableItem_dragIcon__2cvkl","disabled":"SortableItem_disabled__TaYVJ"};